import { Button } from '../Button/Button';
import NotFoundAnim from './NotFoundAnim';
import styles from './notFoundContent.module.scss';

const NotFoundContent = () => {
  return (
    <main className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <article className={styles.textWrapper}>
          <h2 className={styles.title}>Looks like you&#39;re off track</h2>
          <p className={styles.subtitle}>
            We couldn&#39;t find the page you were looking for. Let&#39;s get
            you back.
          </p>
          <Button
            text="Back home"
            variation="transparent"
            link="/"
            styles={styles.button}
          />
        </article>
        <article className={styles.animation}>
          <NotFoundAnim />
        </article>
      </div>
    </main>
  );
};

export default NotFoundContent;
